export const ZipCodeConstants = {
    GET_ZIPCODE: 'GET_ZIPCODE',
    SET_ZIPCODE: 'SET_ZIPCODE'
};